import React from 'react';
import { withRouter } from 'react-router-dom'
import queryString from 'query-string';
import { Container, Box, Grid, Card, Typography, Button, Modal } from '@material-ui/core';
import facebookIcon from '../images/sm_facebook_64px.png';
import twitterIcon from '../images/sm_twitter_64px.png';
import instagramIcon from '../images/sm_instagram_64px.png';
import linkedinIcon from '../images/sm_linkedin_64px.png';
import { Map, InfoWindow, Marker } from 'google-maps-react';
import { LocationOn, Web, Phone, Email } from '@material-ui/icons';
import DoneIcon from '@material-ui/icons/Done';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import goldDesignation from '../images/gold.png';
import platDesignation from '../images/platinum.png';


class Clinic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            base_url: '',
            apibaseurl: '',
            useCurLocation: false,
            Address: '',
            SearchTerm: '',
            Lat: 0,
            Lon: 0,
            DonorEgg: 0,
            MentalHealth: 0,
            MaleCouple: 0,
            GestationalCarrier: 0,
            SingleWomen: 0,
            PGD_PGS: 0,
            DonorEmbryo: 0,
            SingleMen: 0,
            EggCryopreservation: 0,
            Cryopreservation: 0,
            FemaleCouple: 0,
            HIVPatients: 0,
            OutsideMonitoring: 0,
			LGBTQIA: 0,
            MileRadius: 5,
            SortBy: 0,
            PageSize: 20,
            Page: 0,
            ClinicID: 0,
            SatelliteID: 0,
            Clinic: null,
            showingInfoWindow: false,  //Hides or the shows the infoWindow
            activeMarker: {},          //Shows the active marker upon click
            selectedPlace: {},          //Shows the infoWindow to the selected place upon a marker
            openDesignationLegend: false
        };

        this.retrieveData = this.retrieveData.bind(this);
        this.backToSearchResults = this.backToSearchResults.bind(this);
        this.SMLinkClicked = this.SMLinkClicked.bind(this);
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.onMarkerInfoClose = this.onMarkerInfoClose.bind(this);
        this.contactClinic = this.contactClinic.bind(this);
        this.successRates = this.successRates.bind(this);

        this.callClinic = this.callClinic.bind(this);
        this.webClinic = this.webClinic.bind(this);
        this.emailClinic = this.emailClinic.bind(this);
        this.locateClinic = this.locateClinic.bind(this);

        this.handleOpenDesignationLegend = this.handleOpenDesignationLegend.bind(this);
        this.handleCloseDesignationLegend = this.handleCloseDesignationLegend.bind(this);
    }

    handleOpenDesignationLegend() {
        this.setState({
            openDesignationLegend: true,
        })
    }

    handleCloseDesignationLegend() {
        this.setState({
            openDesignationLegend: false,
        })
    }

    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });

    onMarkerInfoClose = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };

    componentDidMount() {
        let params = queryString.parse(this.props.location.search)
        let baseapi = this.props.apibaseurl;
        let base_url = this.props.base_url;

        this.setState({
            base_url: base_url,
            apibaseurl: baseapi
        });

        if (params) {
            //store in state
            this.setState({
                Lat: params.Lat,
                Lon: params.Lon,
                SearchTerm: params.SearchTerm,
                Address: params.Addr ? params.Addr : "Current Location",
                useCurLocation: !params.Addr,
                DonorEgg: params.DonorEgg ? params.DonorEgg : false,
                MentalHealth: params.MentalHealth ? params.MentalHealth : false,
                MaleCouple: params.MaleCouple ? params.MaleCouple : false,
                GestationalCarrier: params.GestationalCarrier ? params.GestationalCarrier : false,
                SingleWomen: params.SingleWomen ? params.SingleWomen : false,
                PGD_PGS: params.PGD_PGS ? params.PGD_PGS : false,
                DonorEmbryo: params.DonorEmbryo ? params.DonorEmbryo : false,
                SingleMen: params.SingleMen ? params.SingleMen : false,
                EggCryopreservation: params.EggCryopreservation ? params.EggCryopreservation : false,
                Cryopreservation: params.Cryopreservation ? params.Cryopreservation : false,
                FemaleCouple: params.FemaleCouple ? params.FemaleCouple : false,
                HIVPatients: params.HIVPatients ? params.HIVPatients : false,
                OutsideMonitoring: params.OutsideMonitoring ? params.OutsideMonitoring : false,
				LGBTQIA: params.LGBTQIA ? params.LGBTQIA : false,
                MileRadius: params.MileRadius ? params.MileRadius : 5,
                SortBy: params.SortBy ? params.SortBy : 0,
                PageSize: params.PageSize ? params.PageSize : 20,
                Page: params.Page ? params.Page : 0,
                ClinicID: params.ID ? params.ID : 0,
                SatelliteID: params.SatID ? params.SatID : 0
            }, this.retrieveData);

            this.props.ga_pageview(window.location.pathname);
        }
        else
        {
            window.location = this.state.base_url + "/Search";
        }
    }

    backToSearchResults() {
        this.props.ga_event('Clinic Detail', 'Back To Results Button Click', this.state.Clinic.Name);

        // if the user clicks back, but we dont have a search term or a location, take them back to the search intro page
        if ((!this.state.Lat || !this.state.Lon) && !this.state.SearchTerm) {

            window.location = this.state.base_url;
            return;
        }

        var searchWithParamsURL = this.state.base_url
            + "/ClinicSearch?Lat=" + this.state.Lat
            + "&Lon=" + this.state.Lon
            + "&SearchTerm=" + this.state.SearchTerm
            + "&Addr=" + this.state.Address
            + "&DonorEgg=" + this.state.DonorEgg
            + "&MaleCouple=" + this.state.MaleCouple
            + "&MentalHealth=" + this.state.MentalHealth
            + "&GestationalCarrier=" + this.state.GestationalCarrier
            + "&SingleWomen=" + this.state.SingleWomen
            + "&PGD_PGS=" + this.state.PGD_PGS
            + "&DonorEmbryo=" + this.state.DonorEmbryo
            + "&SingleMen=" + this.state.SingleMen
            + "&EggCryopreservation=" + this.state.EggCryopreservation
            + "&Cryopreservation=" + this.state.Cryopreservation
            + "&FemaleCouple=" + this.state.FemaleCouple
            + "&HIVPatients=" + this.state.HIVPatients
            + "&OutsideMonitoring=" + this.state.OutsideMonitoring
			+ "&LGBTQIA=" + this.state.LGBTQIA
            + "&MileRadius=" + this.state.MileRadius
            + "&SortBy=" + this.state.SortBy
            + "&Page=" + this.state.Page
            + "&PageSize=" + this.state.PageSize;

        window.location = searchWithParamsURL;
    }

    SMLinkClicked(target) {
        var url = "";
        if (target === "Facebook") {
            this.props.ga_event('Clinic Detail', 'Facebook Link Clicked', this.state.Clinic.Name);
            url = this.state.Clinic.LinkFacebook;
        }
        else if (target === "Instagram") {
            this.props.ga_event('Clinic Detail', 'Instagram Link Clicked', this.state.Clinic.Name);
            url = this.state.Clinic.LinkInstagram;
        }
        else if (target === "Twitter") {
            this.props.ga_event('Clinic Detail', 'Twitter Link Clicked', this.state.Clinic.Name);
            url = this.state.Clinic.LinkTwitter;
        }
        else if (target === "LinkedIn") {
            this.props.ga_event('Clinic Detail', 'LinkedIn; Link Clicked', this.state.Clinic.Name);
            url = this.state.Clinic.LinkLinkedIn;
        }
        else {
            return;
        }

        url = url.trim();
        if (!url.startsWith("https://"))
        {
            url = "https://" + url;
        }
        var win = window.open(url, '_blank');
        if (win) {
            win.focus();
        }
    }

    contactClinic() {
        this.props.ga_event('Clinic Detail', 'Contact Clinic Button Click', this.state.Clinic.Name);

        var url = "https://www.sartcorsonline.com/Home/RequestClinicInfo?clinicId=" + this.state.Clinic.ClinicID;
        var win = window.open(url, '_blank');
        if (win) {
            win.focus();
        }
    }

    webClinic() {
        this.props.ga_event('Clinic Detail', 'Clinic Website Clicked', this.state.Clinic.Name);
        var url = this.state.Clinic.Website.trim();
        if (!url.startsWith("http://") && !url.startsWith("https://")) {
            url = "https://" + url;
        }
        var win = window.open(url, '_blank');
        if (win) {
            win.focus();
        }
    }

    emailClinic() {
        this.props.ga_event('Clinic Detail', 'Clinic Email Clicked', this.state.Clinic.Name);
        var email = this.state.Clinic.Email.trim();
        if (email) {
            email = 'mailto:' + email.trim();
        }
        else {
            return;
        }
        window.open(email, '_self');
    }

    callClinic() {
        this.props.ga_event('Clinic Detail', 'Clinic Phone Clicked', this.state.Clinic.Name);
        var phone = this.state.Clinic.Phone.trim();
        if (phone) {
            phone = 'tel:' + phone.trim().replace(/\D/g, '');
        }
        else {
            return;
        }
        window.open(phone, '_self');
    }

    locateClinic() {
        this.props.ga_event('Clinic Detail', 'Clinic Address Clicked', this.state.Clinic.Name);
        var addr = this.state.Clinic.FullAddress.trim();
        if (addr) {
            addr = 'https://www.google.com/maps/search/?api=1&query=' + addr.trim();
        }
        else
        {
            return;
        }
        var win = window.open(addr, '_blank');
        if (win) {
            win.focus();
        }
    }

    successRates() {
        this.props.ga_event('Clinic Detail', 'Success Rates Button Click', this.state.Clinic.Name);

        var url = "https://sartcorsonline.com/CSR/PublicSnapshotReport?ClinicPKID=" + this.state.Clinic.ClinicID + "&reportingYear=2023";
        if (this.state.Clinic.IsValidationPending) {
            url = "https://www.sart.org/Data_Being_Validated/";
        }
        else if (this.state.Clinic.InGoodStanding) {
            url = "http://www.sart.org/SART_Clinic_In_Good_Standing/";
        }

        var win = window.open(url, '_blank');
        if (win) {
            win.focus();
        }
    }

    retrieveData() {
        let endpoint = this.state.apibaseurl + "Membersearch/Clinic";
        let parambody = JSON.stringify({
            ClinicID: this.state.ClinicID,
            SatelliteID: this.state.SatelliteID
        });

        fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: parambody
        }).then(res => res.json())
            .then((result) => {
                if (!result.msg) {
                    this.setState({
                        Clinic: result
                    });
                }
            },
            (error) =>
            {
                console.log("INSIDE ERROR");
                console.log(error);
            }
        );
    }

    render() {
        return (
            <Container maxWidth={false} disableGutters={true} style={{ background: "#fafafa"}}>
                <Grid container style={{ width: '100%' }}
                    direction="row"
                    justify="center"
                    alignItems="center"
                    className="clinicHeaderPhoto">
                    <Grid item xs={4} sm={3} className="paddingLeftWeb20Mobile5"> 
                        {this.state.Clinic &&
                            <img
                                src={this.state.apibaseurl + "Membersearch/ClinicLogo?clinicId=" + this.state.ClinicID}
                                alt="Clinic Logo"
                                className="clinicLogo"
                                style={{ maxWidth: "100%"}}
                            />
                        }
                    </Grid>
                    <Grid item xs={8} sm={9}>
                        {this.state.Clinic &&
                            <Box className="paddingLeftWeb20Mobile5">
                                <Typography variant="h4" className="clinicHeader" gutterBottom>
                                    {this.state.Clinic.Name}
                                </Typography>
                                {this.state.Clinic.MemberSince &&
                                    <p style={{ margin: "0px" }} className="clinicHeader">{this.state.Clinic.MemberSince}</p>
                                }
                            </Box>
                        }
                    </Grid>
                </Grid>

                <Container maxWidth="xl" style={{ background: "#fafafa" }}>
                    <Grid container
                        className="detailsSectionXS"
                        direction="row"
                        justify="center"
                        alignItems="flex-start"
                        style={{ marginTop: "20px", marginBottom: "20px" }}>
                            <Grid item xs={4}>
                                <Button className="detailsButton" variant="contained" color="default" onClick={this.backToSearchResults} disableElevation><ArrowBackIosIcon />Back to List</Button>
                            </Grid>
                            <Grid item xs={4}>
                                <Button className="detailsButton" variant="contained" color="default" onClick={this.contactClinic} disableElevation>Contact Clinic</Button>
                            </Grid>
                            <Grid item xs={4}>
                                <Button className="detailsButton" variant="contained" color="primary" onClick={this.successRates} disableElevation>Success Rates</Button>
                            </Grid>
                    </Grid>
                    <Grid container
                        className="paddingWeb20Mobile5"
                        direction="row"
                        justify="center"
                        alignItems="flex-start"
                        style={{ paddingTop: "20px"}}>
                        <Grid item sm={9}>
                            
                                <Grid container
                                    className="detailsSectionSM"
                                    direction="row"
                                    spacing={1}
                                    justify="center"
                                    alignItems="flex-start"
                                    style={{padding: "10px"}}
                                >
                                    <Grid item sm={6}>
                                        <Box>
                                            <Button variant="contained" color="default" onClick={this.backToSearchResults} disableElevation><ArrowBackIosIcon />Back to List</Button>
                                        </Box>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <Box style={{ textAlign: "right"}}>
                                            <Button variant="contained" color="default" onClick={this.contactClinic} disableElevation>Contact Clinic</Button>
                                            <br />
                                            <Button variant="contained" color="primary" onClick={this.successRates} disableElevation style={{ marginTop: "5px" }}>Success Rates</Button>
                                        </Box>
                                    </Grid>
                                </Grid>

                            {this.state.Clinic &&
                                <Card className="clinicDetailsCard">
                                    <Box className="detailsSection">
                                        {this.state.Clinic.Overview &&
                                            <Box className="InfoSection">
                                                <Typography variant="h6" className="infoHeader" gutterBottom>
                                                    Overview
                                                </Typography>
                                                <p className="infoIndented">{this.state.Clinic.Overview}</p>
                                            </Box>
                                        }

                                        {this.state.Clinic.Services && this.state.Clinic.Services.length > 0 &&
                                            <Box className="InfoSection">
                                                <Typography variant="h6" className="infoHeader" gutterBottom>
                                                    Services
                                                </Typography>
                                                <Grid container
                                                    direction="row"
                                                    spacing={1}
                                                    justify="flex-start"
                                                    alignItems="flex-start">
                                                    {this.state.Clinic.Services.map((service, idx) => (
                                                        <Grid key={idx} item sm={4} xs={6}>
                                                            <DoneIcon style={{ float: "left" }} />
                                                            <span>{service}</span>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Box>
                                        }

                                        {this.state.Clinic.Members && this.state.Clinic.Members.length > 0 &&
                                            <Box className="InfoSection">
                                                <Typography variant="h6" className="infoHeader" gutterBottom>
                                                    Our Team
                                                </Typography>
                                                <Grid container
                                                    direction="row"
                                                    spacing={1}
                                                    justify="flex-start"
                                                    alignItems="stretch">
                                                    {this.state.Clinic.Members.map((member, idx) => (
                                                        <Grid key={idx} item sm={6} xs={12} style={{ marginTop: '5px' }}>
                                                            <Card variant="outlined" style={{ margin: 'auto', minHeight:'100%' }}>
                                                                <Grid container
                                                                    direction="row"
                                                                    spacing={1}
                                                                    justify="flex-start"
                                                                    alignItems="stretch"
                                                                    >
                                                                    <Grid item xs={12}>
                                                                        <img src={this.state.apibaseurl + "Membersearch/MemberImage?memberId=" + member.ID} className="memberProf" style={{ paddingTop: "10px", paddingBottom: "10px", maxHeight: "350px", margin: "auto", display: "block" }} alt="Member Profile" />
                                                                    </Grid>
                                                                    <Grid item xs={12} style={{paddingLeft:"15px", paddingRight: "15px", paddingBottom: "10px"}}>
                                                                        <Typography variant="h6">
                                                                            {member.FullName}
                                                                        </Typography>
                                                                        <Typography variant="subtitle2" gutterBottom>
                                                                            {member.Role}
                                                                        </Typography>
                                                                        <Typography variant="body2">
                                                                            {member.Bio}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Card>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Box>
                                        }

                                        {this.state.Clinic.Specializations && this.state.Clinic.Specializations.length > 0 &&
                                            <Box className="InfoSection">
                                                <Typography variant="h6" className="infoHeader" gutterBottom>
                                                    Other Services
                                                </Typography>
                                                <Grid container
                                                    direction="row"
                                                    spacing={1}
                                                    justify="flex-start"
                                                    alignItems="flex-start">
                                                    {this.state.Clinic.Specializations.map((spec, idx) => (
                                                        <Grid key={idx} item sm={4} xs={6} style={{ marginTop: '5px' }}>
                                                            <DoneIcon style={{ float: "left" }} />
                                                            <span>{spec}</span>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Box>
                                        }

                                        {this.state.Clinic.CertsAndAccredidations && this.state.Clinic.CertsAndAccredidations.length > 0 &&
                                            <Box className="InfoSection">
                                                <Typography variant="h6" className="infoHeader" gutterBottom>
                                                    Certificates & Accredidations
                                                </Typography>
                                                <Grid container
                                                    direction="row"
                                                    spacing={1}
                                                    justify="flex-start"
                                                    alignItems="flex-start">
                                                    {this.state.Clinic.CertsAndAccredidations.map((cert, idx) => (
                                                        <Grid key={idx} item sm={4} xs={6} style={{ marginTop: '5px' }}>
                                                            <DoneIcon style={{ float: "left" }} />
                                                            <span>{cert}</span>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Box>
                                        }
                                    </Box>
                                </Card> 
                            }                               
                        </Grid>

                        <Grid item sm={3} xs={12} >
                            {this.state.Clinic &&
                                <Card className="clinicDetailsCard" style={{padding:"5px"}}>
                                    <Box className="detailsSection">
                                        <Box style={{ position: 'relative', height: "300px", marginBottom: "20px" }}>
                                            <Map
                                                google={window.google}
                                                zoom={14}
                                                style={{ width: '100%', height: '300px' }}
                                                initialCenter={{
                                                    lat: this.state.Clinic.Latitude,
                                                    lng: this.state.Clinic.Longitude
                                                }}>
                                                <Marker
                                                    onClick={this.onMarkerClick}
                                                    name={this.state.Clinic.Name}
                                                    address={this.state.Clinic.DisplayFullAddress}
                                                />
                                                <InfoWindow
                                                    marker={this.state.activeMarker}
                                                    visible={this.state.showingInfoWindow}
                                                    onClose={this.onMarkerInfoClose}>
                                                    <Box>
                                                        <Typography variant="h6">
                                                            {this.state.selectedPlace.name}
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            {this.state.selectedPlace.address}
                                                        </Typography>
                                                    </Box>
                                                </InfoWindow>
                                            </Map>
                                        </Box>

                                        <Box>
                                            <Grid container
                                                direction="row"
                                                spacing={1}
                                                justify="space-around"
                                                alignItems="center"
                                                style={{ textAlign: "center" }}>
                                                <Grid item xs={12}>
                                                    {this.state.Clinic.ClinicDesignationID == 1 &&
                                                        <img src={goldDesignation} alt="Gold" onClick={this.handleOpenDesignationLegend} className="smLink badgeIcon" />
                                                    }
                                                    {this.state.Clinic.ClinicDesignationID == 2 &&
                                                        <img src={platDesignation} alt="Platinum" onClick={this.handleOpenDesignationLegend} className="smLink badgeIcon" />
                                                    }
                                                </Grid>
                                            </Grid>

                                            <Grid container
                                                direction="row"
                                                spacing={1}
                                                justify="flex-start">
                                                <Grid item xs={12} onClick={this.locateClinic} className="cursorHand">
                                                    <LocationOn color="primary" style={{ float: "left", marginRight:"5px" }} />
                                                    <Typography variant="body2" display="inline" gutterBottom>
                                                        {this.state.Clinic.DisplayFullAddress}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container
                                                direction="row"
                                                spacing={1}
                                                justify="flex-start"
                                                alignItems="flex-start">
                                                <Grid item xs={12} onClick={this.emailClinic} className="cursorHand">
                                                    <Email color="primary" style={{ float: "left", marginRight: "5px" }} />
                                                    <Typography variant="body2" display="inline" gutterBottom>
                                                        {this.state.Clinic.Email}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container
                                                direction="row"
                                                spacing={1}
                                                justify="flex-start"
                                                alignItems="flex-start">
                                                <Grid item xs={12} onClick={this.callClinic} className="cursorHand">
                                                    <Phone color="primary" style={{ float: "left", marginRight: "5px" }} />
                                                    <Typography variant="body2" display="inline" gutterBottom>
                                                        {this.state.Clinic.Phone}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid container
                                                direction="row"
                                                spacing={1}
                                                justify="flex-start"
                                                alignItems="flex-start">
                                                <Grid item xs={12} onClick={this.webClinic} className="cursorHand">
                                                    <Web color="primary" style={{ float: "left", marginRight: "5px" }} />
                                                    <Typography variant="body2" className="cursorHand" display="inline" gutterBottom>
                                                        {this.state.Clinic.Website}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid container
                                                direction="row"
                                                spacing={2}
                                                justify="center"
                                                alignItems="flex-start">
                                                {this.state.Clinic.LinkTwitter &&
                                                    <Grid item xs={3} className="cursorHand">
                                                        <img src={twitterIcon} alt="Twitter" style={{ height: "20px", width: "20px" }} onClick={() => this.SMLinkClicked("Twitter")} className="smLink"/>
                                                    </Grid>
                                                }
                                                {this.state.Clinic.LinkFacebook &&
                                                    <Grid item xs={3} className="cursorHand">
                                                        <img src={facebookIcon} alt="Facebook" style={{ height: "20px", width: "20px" }} onClick={() => this.SMLinkClicked("Facebook")} className="smLink"/>
                                                    </Grid>
                                                }
                                                {this.state.Clinic.LinkInstagram &&
                                                    <Grid item xs={3} className="cursorHand">
                                                        <img src={instagramIcon} alt="Instagram" style={{ height: "20px", width: "20px" }} onClick={() => this.SMLinkClicked("Instagram")} className="smLink"/>
                                                    </Grid>
                                                }
                                                {this.state.Clinic.LinkLinkedIn &&
                                                    <Grid item xs={3} className="cursorHand">
                                                        <img src={linkedinIcon} alt="LinkedIn" style={{ height: "20px", width: "20px" }} onClick={() => this.SMLinkClicked("LinkedIn")} className="smLink"/>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Box>  
                                    </Box>
                                </Card>
                            }
                        </Grid>
                    </Grid>
                </Container>
                <Modal
                    open={this.state.openDesignationLegend}
                    onClose={this.handleCloseDesignationLegend}>
                    <div className="modalStyle" >
                        <div className="modalBody" style={{ textAlign: "center" }}>
                            <h4 className="infoHeader">Clinic Designation Legend</h4>
                        </div>
                        <Grid container
                            className="paddingWeb20Mobile5"
                            direction="row"
                            spacing={1}
                            justify="space-around"
                            alignItems="center"
                            style={{ textAlign: "center" }}>
                            <Grid item xs={12} sm={3}>
                                <img src={goldDesignation} alt="Gold" className="smLink badgeIcon" />
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                GOLD DESIGATION DESCRIPTION
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <img src={platDesignation} alt="Gold" className="smLink badgeIcon" />
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                PLATINUM DESIGATION DESCRIPTION
                            </Grid>
                        </Grid>
                        <hr />
                        <div className="modalFooter">
                            <Button style={{ float: "right", marginBottom: "10px" }} variant="contained" color="primary" onClick={this.handleCloseDesignationLegend}>Close</Button>
                        </div>
                    </div >
                </Modal>
            </Container>
        );
    }
}

export default (withRouter(Clinic));